import { render, staticRenderFns } from "./MakeAccountTurkish.vue?vue&type=template&id=6f1b6fe9&"
import script from "./MakeAccountTurkish.vue?vue&type=script&lang=js&"
export * from "./MakeAccountTurkish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports